import MoreVertSharpIcon from '@mui/icons-material/MoreVertSharp';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { alpha, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import {
  DataGrid, gridClasses, GridToolbar,
} from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import getAllDeploymentDetails from '../../../api/private/deployment/getAllDeploymentDetails';
import CreateNewScheduleModal from './modals/CreateNewSchedule';
import ConfirmationModal from './modals/DeploymentConfirmationModal ';
import EditDeploymentSchedule from './modals/EditDeploymentSchedule';

styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        0.2 + theme.palette.action.selectedOpacity,
      ),
      '&:hover': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          0.2 + theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity,
        ),
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            0.2 + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));

function ReleaseScheduleList({ reload, setReload }) {
  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [pageSize, setPageSize] = React.useState(5);
  const [selectedLog, setSelectedLog] = React.useState({});
  const [selectedLogId, setSelectedLogId] = React.useState();

  const [buttonAnchor, setButtonAnchor] = React.useState(null);
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [previousLogs, setPreviousLogs] = useState([]);
   const [upcomingLogs, setupcomingLogs] = useState([]);

const [loading, setLoading] = useState(true);
const normalizeLogs = (rows) => rows.map((r) => ({
   ...r,
   startDate: r.StartTime?.slice(0, 10) ?? '',
   startTime: r.StartTime?.slice(11, 16) ?? '',
   endDate: r.EndTime?.slice(0, 10) ?? '',
   endTime: r.EndTime?.slice(11, 16) ?? '',
 }));

const fetchLogs = async () => {
 try {
  setLoading(true);
   const response = await getAllDeploymentDetails(1, 100);
   const normalizeedLogs = normalizeLogs(response.data.Data);
   setLoading(false);
   const upcomingRows = normalizeedLogs.filter((row) => new Date(row.StartTime) > new Date() && row.DeploymentMode === 'Yes');
   const previousRows = normalizeedLogs.filter((row) => new Date(row.EndTime) < new Date() || row.DeploymentMode === 'No');
   setPreviousLogs(previousRows);
   setupcomingLogs(upcomingRows);
 } catch (error) {
   if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
     // Ignore cancel error
     return;
   }
   console.error('API error:', error);
 }
};
    useEffect(() => {
      fetchLogs();
    }, []);

        useEffect(() => {
      fetchLogs();
    }, [reload]);

  const handleMenuOpen = (event, row) => {
   event.stopPropagation();
    setSelectedLogId(row.LogId);
    setSelectedLog(row);
    setButtonAnchor(event.currentTarget);
  };

  const handleMenuClose = (event) => {
    event.stopPropagation();
    setSelectedLogId(null);
    setButtonAnchor(null);
  };

  const columns = [
    {
      field: 'LogId',
      headerName: 'Id',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      flex: 1,
      minWidth: 180,

    },
    {
      field: 'startTime',
      headerName: 'Start Time',
      flex: 1,
      minWidth: 180,
    },
       {
      field: 'endDate',
      headerName: 'End Date',
      flex: 1,
      minWidth: 150,

    },
    {
      field: 'endTime',
      headerName: 'End Time',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'CreatedBy',
      headerName: 'Created By',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 100,
      renderCell: (dep) => (
        <>
          <Button
            size="small"
            onClick={(event) => {
              handleMenuOpen(event, dep.row);
            }}
            onClose={(event) => handleMenuClose(event)}
          >
            <MoreVertSharpIcon />
          </Button>
          <Menu
            id={`menu-${dep.Id}`}
            anchorEl={buttonAnchor}
            open={selectedLogId === dep.row.LogId}
            onClose={(event) => handleMenuClose(event)}
          >
            <div>

                  <MenuItem
                  Id={selectedLogId}
                  onClick={() => {
            setOpenEdit(true);
          }}
                  >
                      Edit
                  </MenuItem>
                    <MenuItem
Id={selectedLogId}
                  onClick={() => {
            setOpenCancel(true);
            setShowConfirmation(true);
          }}
                    >
                    Cancel
                    </MenuItem>
            </div>
          </Menu>
        </>
      ),
    },
  ];
const PreviousColumns = [
    {
      field: 'LogId',
      headerName: 'Id',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      flex: 1,
      minWidth: 180,

    },
    {
      field: 'startTime',
      headerName: 'Start Time',
      flex: 1,
      minWidth: 180,

    },
       {
      field: 'endDate',
      headerName: 'End Date',
      flex: 1,
      minWidth: 150,

    },
    {
      field: 'endTime',
      headerName: 'End Time',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'CreatedBy',
      headerName: 'Created By',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'Status',
      headerName: 'Status',
      width: 100,
    },
  ];

  const handleProcessRowUpdateError = React.useCallback((error) => {
    toast.error(error);
  }, []);

  const handleConfirm = async (confirmed) => {
    try {
      if (confirmed) {
        setShowConfirmation(false);
        // Disableuser();
      } else {
        setShowConfirmation(false);
      }

      // toast.success('Attribute successfully created for new sites');
    } catch (error) {
      toast.error('An error occurred during finalization');
    }
  };
  return (
    <>
      {showConfirmation && (
        <ConfirmationModal
          onUpdateSuccess={(updatedRow) => {
                setupcomingLogs((prevRows) => prevRows.map((row) => (row.LogId === updatedRow.LogId ? updatedRow : row)));
                fetchLogs();
              }}
          open={showConfirmation}
          onClose={() => setShowConfirmation(false)}
          onConfirm={() => handleConfirm(true)} // Pass true for confirmation
          onCancel={() => handleConfirm(false)} // Pass false for cancellation
          message="the sceduled deployment cannot be undone. Are you sure you want to proceed?"
          Log={selectedLog}
        />
      )}
      <div className="width: '100%'; margin-right: -20px;">
        <Box
          component="div"
           sx={{
            width: '100%',
            mt: -1,
            ml: 3.5,
            mr: -30,
          }}
        >
            <Typography
                        variant="h5"
                        sx={{
                          color: '#384451',
                          marginTop: 1,
                        }}
            >
                        Upcoming
            </Typography>
          {openEdit
            && (
              <EditDeploymentSchedule
              onUpdateSuccess={(updatedRow) => {
                setupcomingLogs((prevRows) => prevRows.map((row) => (row.LogId === updatedRow.LogId ? updatedRow : row)));
                fetchLogs();
              }}
              open={openEdit}
              Id={selectedLogId}
              row={selectedLog}
              handleClose={() => {
                setOpenEdit(false);
              }}
              fetchLogs={fetchLogs}
              cancel={openCancel}
              />
            )}
          {open && (
            <CreateNewScheduleModal
            onAddSuccess={() => {
                fetchLogs();
              }}
              open={open}
              handleClose={() => {
                setOpen(false);
              }}
            />
          )}
          <DataGrid
           minHeight="100vh"
            rows={upcomingLogs}
            columns={columns}
            experimentalFeatures={{ newEditingApi: true }}
            getRowId={(r) => r.LogId}
            slots={{
              toolbar: GridToolbar,
            }}
            loading={loading}
            onProcessRowUpdateError={handleProcessRowUpdateError}
            disableSelectionOnClick
            className="bg-white"
            getRowHeight={() => 'auto'}
            sx={{
              '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
              '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
              '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
            }}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            pagination
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 15]}
            getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
          />
        </Box>
      </div>
       <div className="width: '100%'; margin-right: -20px;">
        <Box
          component="div"
           sx={{
            width: '100%',
            mt: -1,
            ml: 3.5,
            mr: -30,
          }}
        >
            <Typography
                        variant="h5"
                        sx={{
                          color: '#384451',
                          marginTop: 7,
                        }}
            >
                        Previous
            </Typography>
          <DataGrid
            rows={previousLogs}
            columns={PreviousColumns}
            experimentalFeatures={{ newEditingApi: true }}
            getRowId={(r) => r.LogId}
            slots={{
              toolbar: GridToolbar,
            }}
            onProcessRowUpdateError={handleProcessRowUpdateError}
            disableSelectionOnClick
            className="bg-white"
            minHeight="100vh"
            getRowHeight={() => 'auto'}
            sx={{
              '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
              '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
              '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
            }}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            pagination
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 15]}
            loading={loading}
            getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
          />
        </Box>
       </div>
    </>

  );
}

export default ReleaseScheduleList;
